import { Component, OnInit, Inject, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDatepickerInputEvent } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ApiService } from '../../_services';
import { DependentService } from '../../_services/dependent.service';
import { MemberService } from '../../_services/member.service';
import { Dependent } from '../../_models/dependent.model';
import { parsePhoneNumber, PhoneNumber, AsYouType } from "libphonenumber-js";
import { AppComponent } from '../../app.component';
import * as moment from 'moment';



@Component({
  selector: 'app-dependent-form',
  templateUrl: './dependent-form.component.html',
  styleUrls: ['./dependent-form.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class DependentFormComponent implements OnInit {
  public lisRelationshipCode = [];

  applicantForm: FormGroup = new FormGroup({});

  currentDependent : Dependent = {} as any; // model for create new or edit
  currentMember: any;
  isShow = false;
  toDay = new Date()
  tooltipNotification: string = 'Since this dependent is 18 years or older, they must have their own LIFE Gateway account to access Telemed, This requires they have an email that will be used as their login.'
  isSave: boolean = false;
  productId: string;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<DependentFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any,
    private dependentService: DependentService,
  ) {
    this.currentMember =  JSON.parse(localStorage.getItem('currentMember'));
    this.currentDependent = data.currentDependent;
    if(this.currentDependent.dob){
      this.currentDependent.dob = moment(this.currentDependent.dob).add(moment(this.currentDependent.dob).utcOffset() * -1, 'minutes').toDate();
    }
    //this.currentDependent.dob = new Date('1/19/1999'); this.currentDependent.email='kientrung19120000@gmail.com'; this.currentDependent.phone1='8006589632';this.currentDependent.lastName = 'test'; this.currentDependent.firstName='test'; this.currentDependent.relationshipCodeId=2
    this.productId = AppComponent.whitelabel.productId;
  }

  ngOnInit() {

    this.applicantForm = this.fb.group({
      gender: ['', [Validators.required]],
      relationship: ['', [Validators.required,Validators.min(1)]],
      dob: ['', [Validators.required]],
      firstName: ['', Validators.required],
      lastName: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required]]
    })
    if (this.currentDependent.dependentId) {
        this.isShow = new Date().getFullYear() - new Date(this.currentDependent.dob).getFullYear() >= 18? true : false
        if (!this.isShow) {
          this.applicantForm.controls['email'].clearValidators();
          this.applicantForm.controls['email'].updateValueAndValidity()
          this.applicantForm.controls['phone'].clearValidators();
          this.applicantForm.controls['phone'].updateValueAndValidity()
        }else{
          this.applicantForm.controls['email'].setValidators([Validators.required, Validators.email])
          this.applicantForm.controls['email'].updateValueAndValidity()
          this.applicantForm.controls['phone'].setValidators(Validators.required)
          this.applicantForm.controls['phone'].updateValueAndValidity()
    
        }
    }

    this.dependentService.getRelationshipCode().subscribe(r=>{
      this.lisRelationshipCode = r;
      if(!this.currentDependent.dependentId){
        this.currentDependent.relationshipCodeId = 0;
        this.currentDependent.gender = 'male';
        this.currentDependent.over18 = 'true' as any;
      }
    })

    // console.log(this.applicantForm.invalid)
  }


  async submitDependent(){
    this.isSave = true;
    if (this.currentDependent.dependentId) {
      this.editNewDependent();
    }else{
      await this.dependentService.checkEmailExist(this.currentDependent).subscribe(r => {
        if (r) { //email exist
          this.applicantForm.controls['email'].setValidators([ Validators.maxLength(0)])
          this.applicantForm.controls['email'].updateValueAndValidity();
          this.applicantForm.controls['email'].clearValidators()
          this.applicantForm.controls['email'].setValidators([ Validators.email, Validators.required])
          this.editNewDependent();
          // console.log(this.applicantForm)
          return
        }else{
          this.applicantForm.controls['email'].clearValidators()
          this.applicantForm.controls['email'].setValidators([ Validators.email, Validators.required])
          this.applicantForm.controls['email'].updateValueAndValidity();
          this.editNewDependent();
  
        }
      })
    }
    //check email
    // this.editNewDependent();
    //check form valid
    

  }

  calculateAge(birthday) { // birthday is a date
    var ageDifMs = Date.now() - birthday.getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
 }

  editNewDependent(){
    if (this.applicantForm.invalid) {
      Object.keys(this.applicantForm.controls).forEach(k=>{
          this.applicantForm.controls[k].markAsTouched()
      })
      this.isSave = false
      return;
    }
    // console.log(this.applicantForm)
    if (this.currentDependent.dependentId) { //update
      this.currentDependent.over18 = this.calculateAge(this.currentDependent.dob)>= 18;
      this.currentDependent.relationshipCodeId = +this.currentDependent.relationshipCodeId;
      this.dependentService.updateDependent(this.currentDependent).subscribe(r=>{
        this.dialogRef.close(r);
      })

    }else{  //new
      this.currentDependent.over18 = this.calculateAge(this.currentDependent.dob)>= 18;
      this.currentDependent.parentMemberId = this.currentMember.memberId;
      this.dependentService.createNewDependent(this.currentDependent, this.productId).subscribe(r=>{
        this.dialogRef.close(r);
      })
    }
  }

  cancel(){
      this.dialogRef.close();
  }

  dobChange(e: MatDatepickerInputEvent<Date>){
    var tempDate = new Date()
    // console.log(this.applicantForm)
    this.isShow = tempDate.getFullYear() - e.value.getFullYear() >= 18 ? true: false;
    if (!this.isShow) {
      this.applicantForm.controls['email'].clearValidators();
      this.applicantForm.controls['email'].updateValueAndValidity()
      this.applicantForm.controls['phone'].clearValidators();
      this.applicantForm.controls['phone'].updateValueAndValidity()
    }else{
      this.applicantForm.controls['email'].setValidators([Validators.required, Validators.email])
      this.applicantForm.controls['email'].updateValueAndValidity()
      this.applicantForm.controls['phone'].setValidators(Validators.required)
      this.applicantForm.controls['phone'].updateValueAndValidity()

    }
  }

  phoneChange(e){
    // console.log(new AsYouType('US').input(e))
    const phoneNumber = new AsYouType('US').input(e)
    var check = parsePhoneNumber(phoneNumber, 'US').isValid()
    if (!check) {//invalid
      // this.applicantForm.controls['phone'].setErrors({required: true})
      this.applicantForm.controls['phone'].setValidators([ Validators.requiredTrue])
      this.applicantForm.controls['phone'].updateValueAndValidity()
      // console.log(this.applicantForm)
    }else{//valid
      this.applicantForm.controls['phone'].clearValidators();
      this.applicantForm.controls['phone'].setValidators([ Validators.required])
      this.applicantForm.controls['phone'].updateValueAndValidity()
    }
  }


  onDobChange(e){
    // console.log(e)
    // var tempDate = new Date()
    // console.log(moment().isBefore(e))    
    // if (tempDate.getFullYear() < new Date(e).getFullYear() ) {
    //   console.log(e)
    // }
  }

}



// WEBPACK FOOTER //
// ./src/app/dependent/dependent-form/dependent-form.component.ts